theme.add_to_cart_btn = function(){
  var loginPageFormSubmit = setInterval(function() {
     var text_price = $('.variant__price_subscription').text();
      if(text_price != ''){
        $('.add-to-cart-wishlist-wrapper .add-to-cart').removeClass('disable');
        clearInterval(loginPageFormSubmit);
      }
    },100);
}
theme.default_select = function(){
  function defaultSelect(){
    var varPlan =  $('.slick-active .subscription-plan-1').attr('data-plan-variant-option');
    var varPrice =  $('.slick-active .subscription-plan-1').attr('var-price');
    $('.slick-active .variant__price_subscription').text(varPrice);
    $(".rc_widget__option__plans__dropdown option").each(function(){
      var option_attr_val = $(this).attr('data-plan-option');
      if( option_attr_val == varPlan){
        var option_value = $(this).val();
        $(".rc_widget__option__plans__dropdown").val(option_value).trigger("change");
      }
    });
  }
  const myTimeout = setTimeout(defaultSelect, 5000);
}
theme.single_subscription_membership = function(){
   $('.subscription-membership-plan-card').on('change',function(){
    $(`.subscription-membership-plan-card[var-id="${$(this).attr('var-id')}"]`).click();
  //  $('.subscription-membership-plan-card').removeAttr('checked');
    var varPrice = $(this).attr('var-price');
    $('.variant__price_subscription').text(varPrice);
    // var checked = $(this).attr('checked','checked');
    var variantPlan = $(this).attr('data-plan-variant-option');
    var varId = $(this).attr('var-id');
    $(".product-single__variants").val(varId).trigger("change");
    // console.log('Is id store',($(this).val()));
    $(".rc_widget__option__plans__dropdown option").each(function(){
      var option_attr_val = $(this).attr('data-plan-option');
      if(option_attr_val == variantPlan){
        var option_value = $(this).val();
        $(".rc_widget__option__plans__dropdown").val(option_value).trigger("change");
      }
    });
  });
}
theme.middle_bottom_trigger = function(){
  //middle subscription button
  $(document).on("click",".middle-subscription-btn",function(e) {
  //  $('.middle-subscription-btn').click(function(e){
    e.preventDefault();
    console.log("middle susbcripton working");
    $(this).closest('.subscription_content_wrap').find('.add-to-cart-subscription').trigger('click');
  });
  //bottom subscription button
  $(document).on("click",".down-subscription-btn",function(e){
    e.preventDefault();
    $(this).closest('.subscription_content_wrap').find('.add-to-cart-subscription').trigger('click');
  });
}
theme.addon_body_click = function(){
  $('body').on('touchstart  click',function(e){
    if($(e.target).closest('.subscribe_addon_data_form_wrap_inner').length == 0 && $(e.target).closest('.add-to-cart-wishlist-wrapper').length == 0){
      $('.subscribe_addon_data_form_wrap').css('display','none');
      $("body").removeClass("subscription-addon-details-open");
    }
  });
}
theme.addon_subscribe_btn_click = function(){
  $('.subscribe_close').on('click',function(){
    $('.subscribe_addon_data_form_wrap').css('display','none');
    $("body").removeClass("subscription-addon-details-open");
  });
}

// subscription atc event start

theme.subscriptionAddtocartevent = function(){
  $('.add-to-cart-subscription').off().on('click', function(e){
    console.log('clickk');
    if($('.subscribe_addon_data_form_wrap').css('display') == 'none'){
      $("body").addClass("subscription-addon-details-open");
      $('.subscribe_addon_data_form_wrap').css('display','block');
      var variant_price = $(this).parents('.checkout__btn_subscription').find('.variant__price_subscription').text();
      console.log("variant price",variant_price);
      $('.slick-active .subscribe-price').html(variant_price);
      return false;
    }
    e.preventDefault();
    var $this = $(this);
    var hasClass = $this.parents(".subscription_content_wrap").hasClass("slick-active");
    if(hasClass){
      console.log("this : ",$(this));
      var parent_class = $(this).parents(".product-single__meta").find(".subscription__plans .subscription-membership-plan-card:radio:checked");
      console.log('parent_class',parent_class);
      var variant_id , qty , selling_plan;
      variant_id = parent_class.attr("var-id") , qty = 1 , selling_plan = parent_class.attr("plan-id");
      // $(parent_class).each(function(){
      //   if($(this).is(':checked')){
      //     variant_id = $(this).attr("var-id") , qty = 1 , selling_plan = $(this).attr("plan-id");
      //     // console.log(variant_id);
      //   }
      // });

  //  var data = {
  //       "id": variant_id,
  //       "quantity": qty,
  //       "selling_plan": selling_plan
  //     }
      var form_data = $this.parents(".product-single__meta").find(".product-single__form").serializeArray();
      // if(window.innerWidth < 992){ }
      // else{
      //   form_data.push({name : "selling_plan" , value : selling_plan});
      // }
        var choice = false , size = false , gender = false , val_choice = [] , val_size , val_gender;
       
            if($('.slick-active #add_on_data :checkbox:checked').length > 0){
            choice = true; 
            $(".slick-active #add_on_data :checkbox:checked").each(function() {
              val_choice.push($(this).val());
            });
            $('.slick-active #custom_field_choice').val(val_choice);
           }else{
             choice = false;
           }
          if ($('.slick-active #add_on_size :radio:checked').length > 0){
            size = true;
            val_size = $('.slick-active #add_on_size :radio:checked').val();
            $('.slick-active #custom_field_size').val(val_size);
           }
           else{
             size = false;
           }
           if ($('.slick-active #add_on_gender :radio:checked').length > 0){
            gender = true;
            val_gender = $('.slick-active #add_on_gender :radio:checked').val();
            $('.slick-active #custom_field_gender').val(val_gender);
           }
           else{
             gender = false;
           }
            $('.subscribe_addon_data_form_wrap').css('display','none');
            if(selling_plan != '' && selling_plan != undefined){
              form_data.push({name : "selling_plan" , value : selling_plan});
            }
            if(val_choice != '' && val_choice != undefined){
              form_data.push({name : "properties[Choice]" , value : val_choice});
            }
            if(val_size != '' && val_size != undefined){
              form_data.push({name : "properties[Size]" , value : val_size});
            }
            if(val_gender != '' && val_gender != undefined){
              form_data.push({name : "properties[Gender]" , value : val_gender});
            }
            // return true;
          
     
      
      
      console.log("Form data",form_data);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form_data,
        dataType: 'json',
        success: function(cart) {
          console.warn(cart); 
          $('.subscribe_addon_data_form_wrap').css('display','none');
          $("body").removeClass("subscription-addon-details-open");
          // window.location.href = '/cart'; 
          
            // theme.cart.addItemFromForm(form_data);
            // $('.js-drawer-open-cart').click(form_data);
            // theme.cart.getCart();
            $('body').trigger('added.ajaxProduct', $this.$addToCart);
        }
      });
      
    }
  });
}



// subscription atc event end


theme.membership_slider = function(){
  $('.slider-for').slick({
    infinite: false, 
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    centerMode: true,
    centerPadding: '23%',
    asNavFor: '.slider-nav',
    dots:false
   });
   $('.slider-nav').slick({
    infinite: false,
    slidesToShow: 1,
    asNavFor: '.slider-for',
    dots: true,
    arrows: false,
    focusOnSelect: true,
    swipe:false,
    fade: true ,
    dots: false
   });
}

$(document).ready(function(){
  theme.add_to_cart_btn();
  theme.default_select();
  theme.single_subscription_membership();
  theme.subscriptionAddtocartevent();
  theme.middle_bottom_trigger();
  theme.addon_body_click();
  theme.addon_subscribe_btn_click();
  $(".product-single__meta .subscription__plans .subscription-membership-plan-card:first").click();
   /*====================== Membership slider Start======================*/
  theme.membership_slider();  

    $('.slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
      if($(".slick-active .product-single__meta .subscription__plans .subscription-membership-plan-card:radio:checked").length == 0){
        $(".slick-active .product-single__meta .subscription__plans .subscription-membership-plan-card:first").click();
      }
      // theme.middle_bottom_trigger();
    });
  /*====================== Membership slider End======================*/

  
});

$(window).resize(function(){
  $('.slider-nav').slick('resize');
  $('.slider-for').slick('resize');
});
let portrait = window.matchMedia("(orientation: portrait)");

portrait.addEventListener("change", function(e) {
  $('.slider-nav').slick('resize');
  $('.slider-for').slick('resize');
});